import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]
  static values = {
    timeout: {type: Number, default: 3000},
    leaveDuration: {type: Number, default: 300},
  }

  connect() {
    this.hideTimeouts = new Map()
    this.removeTimeouts = new Map()

    for (const message of this.messageTargets) {
      this.show(message)
      this.scheduleHide(message)
    }
  }

  disconnect() {
    for (const timeoutId of this.hideTimeouts.values()) {
      clearTimeout(timeoutId)
    }
    for (const timeoutId of this.removeTimeouts.values()) {
      clearTimeout(timeoutId)
    }
  }

  pause(event) {
    console.log("tata")
    const message = this.resolveMessage(event)
    if (!message) return

    this.clearHideTimeout(message)
  }

  resume(event) {
    console.log("tata")
    const message = this.resolveMessage(event)
    if (!message || message.dataset.closing === "true") return

    this.scheduleHide(message)
  }

  close(event) {
    event.preventDefault()

    const message = this.resolveMessage(event)
    if (!message) return

    this.hide(message)
  }

  show(message) {
    message.classList.add("opacity-0", "translate-y-2")

    requestAnimationFrame(() => {
      message.classList.remove("opacity-0", "translate-y-2")
      message.classList.add("opacity-100", "translate-y-0")
    })
  }

  hide(message) {
    if (message.dataset.closing === "true") return

    message.dataset.closing = "true"
    this.clearHideTimeout(message)
    this.clearRemoveTimeout(message)

    message.classList.remove("opacity-100", "translate-y-0")
    message.classList.add("opacity-0", "translate-y-2")

    const timeoutId = window.setTimeout(() => {
      message.remove()

      if (!this.hasMessageTarget) {
        this.element.remove()
      }
    }, this.leaveDurationValue)

    this.removeTimeouts.set(message, timeoutId)
  }

  scheduleHide(message) {
    this.clearHideTimeout(message)

    const timeoutId = window.setTimeout(() => {
      this.hide(message)
    }, this.timeoutValue)

    this.hideTimeouts.set(message, timeoutId)
  }

  clearHideTimeout(message) {
    const timeoutId = this.hideTimeouts.get(message)
    if (!timeoutId) return

    clearTimeout(timeoutId)
    this.hideTimeouts.delete(message)
  }

  clearRemoveTimeout(message) {
    const timeoutId = this.removeTimeouts.get(message)
    if (!timeoutId) return

    clearTimeout(timeoutId)
    this.removeTimeouts.delete(message)
  }

  resolveMessage(event) {
    const closestMessage = event.target.closest('[data-flash-target="message"]')
    if (!closestMessage) return null

    return closestMessage
  }
}
